import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=4aac651c&scoped=true&"
import script from "./Diff.vue?vue&type=script&lang=ts&"
export * from "./Diff.vue?vue&type=script&lang=ts&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=4aac651c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aac651c",
  null
  
)

export default component.exports